import { useMemo } from 'react';
import { Column } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { ServiceBillingInlineSettings } from "../../../../../components/ServiceDetails/ServiceBillingInlineSettings/ServiceBillingInlineSettings";
import { useFeatureFlags } from "../../../../../hooks/useFeatureFlags";
import { AgreementDataModel, serviceModel } from "../../../../../models";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetServiceBillingModalContentTID = parentTestId => getTestIds(parentTestId);
export const ServiceBillingModalContent = _ref => {
  let {
    draft,
    service,
    setDraft,
    testid
  } = _ref;
  const testIds = useMemo(() => GetServiceBillingModalContentTID(testid), [testid]);
  const featureFlags = useFeatureFlags();
  const onChangeService = updatedService => {
    setDraft(draft.setService(service.id, () => updatedService));
  };
  const onDayOfMonthChange = (_, dayOfMonth) => {
    setDraft(draft.setService(service.id, s => serviceModel.setBillingDayOfMonth(s, dayOfMonth)));
  };
  const onDayOfWeekChange = (_, dayOfWeek) => {
    setDraft(draft.setService(service.id, s => serviceModel.setBillingDayOfWeek(s, dayOfWeek)));
  };
  const onBillUpfrontModeChange = (_, billUpfront) => {
    setDraft(draft.setService(service.id, s => serviceModel.setBillUpfront(s, billUpfront)));
  };
  const onDayOfYearChange = (_, dayOfYear) => {
    setDraft(draft.setService(service.id, s => serviceModel.setBillingDayOfYear(s, dayOfYear)));
  };
  const onPausedChange = (_, paused) => {
    setDraft(draft.setService(service.id, s => serviceModel.setPaused(s, paused)));
  };
  const onBillOnAcceptanceChange = (_, billOnAcceptance) => {
    setDraft(draft.setService(service.id, s => serviceModel.setSkipBillingOnAcceptance(s, !billOnAcceptance, featureFlags)));
  };
  const onStartBillingAtChange = (_, startBillingAt) => {
    setDraft(draft.setService(service.id, s => serviceModel.setStartBillingAt(s, startBillingAt)));
  };
  return /*#__PURE__*/_jsx(Column, {
    gap: 24,
    "data-testid": testIds.ServiceBillingModalContentTestIds.Root(),
    children: /*#__PURE__*/_jsx(ServiceBillingInlineSettings, {
      service: service,
      testid: testIds.ServiceBillingModalContentTestIds.BillingInlineSettings(),
      agreementData: AgreementDataModel.fromDraft(draft),
      billingInitiation: {
        isExistingService: false
      },
      relationshipState: {
        type: 'awaitingApproval',
        effectiveDate: draft.effectiveDateAsDate()
      },
      onChangeService: onChangeService,
      onDayOfMonthChange: onDayOfMonthChange,
      onDayOfWeekChange: onDayOfWeekChange,
      onDayOfYearChange: onDayOfYearChange,
      onBillUpfrontModeChange: onBillUpfrontModeChange,
      onPausedChange: onPausedChange,
      onBillOnAcceptanceChange: onBillOnAcceptanceChange,
      onStartBillingAtChange: onStartBillingAtChange
    })
  });
};